import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
  createSelector
} from '@reduxjs/toolkit'
import type { RootState } from '../../store'
import { API_PATH } from '../../constants';
import { GameStatus } from '../../Classes1';
import { IGameStatus } from '../../interfaces';
import { http } from '../../utils/config';
import { AxiosResponse } from 'axios';

const gameStatusAdapter = createEntityAdapter<IGameStatus>({
  selectId: (gameStatus: IGameStatus) => gameStatus.gameId,
})

const initialState = gameStatusAdapter.getInitialState()

// Thunk functions
export const fetchGameStatus = createAsyncThunk('gameStatus/fetchGameStatus', async (gameId: string | undefined, { rejectWithValue }) => {
  try {
    const response = await http.get(`${API_PATH}/game/${gameId}/status/`);
    const gameStat: IGameStatus = JSON.parse(JSON.stringify(response.data));
    const gameStatArray: IGameStatus[] = [];
    gameStatArray.push(gameStat)
    return gameStatArray;
  } catch (error: any) {
    if (error.response && (error.response.data.message || error.response.data.error)) {
      const axiosResp = error.response as AxiosResponse;
      const status = new GameStatus();
      return [{
        ...status,
        errorCode: axiosResp.status,
        error: axiosResp.data.message || error.response.data.error,
      }];
    } else {
      return rejectWithValue(error.message)
    }
  }
})

const gameStatusSlice = createSlice({
    name: 'gameStatus',
    initialState,
    reducers: {
      gameStatusToggled(state, action) {
        //const scenarioId = action.payload
      },
    },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGameStatus.fulfilled, (state, action) => {
        gameStatusAdapter.setAll(state, action.payload)
      })
  }
})

export const {
  gameStatusToggled
} = gameStatusSlice.actions

export default gameStatusSlice.reducer

export const {
  selectAll: selectGameStatus
} = gameStatusAdapter.getSelectors((state: RootState) => state.gameStatus)

export const selectGamesStatus = createSelector(
  selectGameStatus,
  (gameStatus: IGameStatus[]) => { 
    return gameStatus.map((gameStatus: IGameStatus) => {
      return gameStatus;
    })
  }
)
